import React from 'react';
import { number, string, shape } from 'prop-types';

import { commaCheck, getDecimals } from '../../utils/pricing-helper';

import './price-block.scss';

export const PriceBlock = ({ rentalPrice }) => {
  const price = commaCheck(rentalPrice.price);
  const priceInDecimal = getDecimals(rentalPrice.price);
  const { duration } = rentalPrice;

  const ariaPriceLabel = `${price} dollars and ${priceInDecimal} cents`;

  return (
    <div className="price-block">
      <div className="price-block-bar">
        <div className="price-rate">
          <div aria-label={ariaPriceLabel} className="price-format__main-price">
            <div aria-label={ariaPriceLabel} className="price-format__symbols">$</div>
            <div aria-label={ariaPriceLabel} className="price-format__dollar">{price}</div>
            <div aria-label={ariaPriceLabel} className="price-format__symbols">{priceInDecimal}</div>
          </div>
          <div className="price-rate__label">
            <div className="price-duration">{duration}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

PriceBlock.displayName = 'PriceBlock';

PriceBlock.propTypes = {
  rentalPrice: shape({
    price: number.isRequired,
    duration: string.isRequired,
    promotion: string
  }).isRequired
};
